import React from 'react';
import { Link } from 'react-router-dom';
import ComponentHeader from '../../ecap/ComponentHeader';
import Swoosh from './Swoosh';

export const TopDashboardComponent = (props) => {
  return (
    <>
      {props.appendText === 'related-careers' && (
        <Swoosh color={props.tenant.secondary} />
      )}
      <img
        src={props.cornerImage}
        className="top-dashboard-component-image"
        alt={props.altText}
      />
      <div>
        <ComponentHeader
          parent="dashboard"
          headerText={props.headerText}
          tenant={props.tenant}
          headerStyle={props.headerStyle}
          appendText={props.appendText}
          reduced
        />
        <div className={`${props.appendText}__description-container`}>
          <p className={`${props.appendText}__description`}>
            <b className={`${props.appendText}__header-bold`}>
              {props.headerText === 'Universal Learner Courses' &&
                props.headerText}
            </b>
            {props.copyDescription}
          </p>
          {props.websiteLink.includes('career-search') ? (
            <Link to="career-search">
              <div
                className={`${props.appendText}__big-link ${props.appendText}__link`}
                style={props.primaryColor}
              >
                {props.copyWebsiteLink}
              </div>
            </Link>
          ) : (
            <a
              rel="noreferrer noopener"
              target="_blank"
              href={props.websiteLink}
              style={props.primaryColor}
              className={`${props.appendText}__big-link ${props.appendText}__link`}
            >
              {props.copyWebsiteLink}
            </a>
          )}
        </div>
      </div>
    </>
  );
};
